<template>
  <!-- 分享 -->
  <div>
    <div
      aria-labelledby="myModalLabel"
      class="modal fade"
      id="share2"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
            <ul class="nav nav-tabs modal-tabs" id="myTab">
              <li class="active">
                <a
                  data-toggle="tab"
                  href="#share-link"
                  @click="switchTab('share-link')"
                  >链接分享</a
                >
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#share-user"
                  @click="switchTab('share-user')"
                  >用户分享</a
                >
              </li>
              <li>
                <a
                  data-toggle="tab"
                  href="#share-group"
                  @click="switchTab('share-group')"
                  >群组分享</a
                >
              </li>
            </ul>
          </div>
          <div class="modal-body">
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade in active" :id="activeTab">
                <div class="prompt" v-show="activeTab === 'share-link'">
                  <span class="text-danger2"
                    >请各位师生遵守<a
                      target="_blank"
                      href="http://www.gov.cn/zwgk/2013-02/08/content_2330133.htm"
                      >《信息网络传播权保护条例》</a
                    >，勿分享侵权违法内容。</span
                  ><br />
                  <i class="ti-link"></i
                  >创建一个分享链接，可设置密码和有效期策略。
                </div>
                <div class="prompt" v-show="activeTab === 'share-user'">
                  <span class="text-danger2"
                    >请各位师生遵守<a
                      target="_blank"
                      href="http://www.gov.cn/zwgk/2013-02/08/content_2330133.htm"
                      >《信息网络传播权保护条例》</a
                    >，勿分享侵权违法内容。</span
                  ><br />
                  <i class="ti-user"></i>输入姓名/GID/邮箱，搜索要分享的用户。
                </div>
                <div class="prompt" v-show="activeTab === 'share-group'">
                  <span class="text-danger2"
                    >请各位师生遵守<a
                      target="_blank"
                      href="http://www.gov.cn/zwgk/2013-02/08/content_2330133.htm"
                      >《信息网络传播权保护条例》</a
                    >，勿分享侵权违法内容。</span
                  ><br />
                  <i class="ti-user"></i
                  >分享给指定群组，群组成员都可以访问分享的资源。
                </div>

                <div class="form-group">
                  <input
                    class="form-control"
                    placeholder="分享标题"
                    type="text"
                    v-model.trim="form.title"
                    name="title1"
                    data-vv-as="分享标题 "
                    v-validate="{ required: true, min: 1, max: 100 }"
                  />
                  <span class="help-block" v-show="errors.has('title1')">{{
                    errors.first("title1")
                  }}</span>
                </div>

                <div
                  class="form-group user-search-from1"
                  v-show="activeTab == 'share-user'"
                >
                  <div class="share-user">
                    <div
                      class="list"
                      v-for="user in form.users"
                      :key="user.user_number"
                    >
                      <img :src="user.avatar" />
                      <p>{{ user.name }}（{{ user.email }}）</p>
                      <i
                        class="iconfont icon-close close"
                        @click="removeUser(user)"
                      ></i>
                    </div>
                    <input
                      ref="userSearch"
                      type="text"
                      class="share-input"
                      v-model.trim="searchUserName"
                      placeholder="输入姓名/GID/邮箱，进行精确搜索"
                    />
                    <div
                      class="share-search user-search-to1"
                      v-show="searchUsers.length && showSearchList"
                    >
                      <ul>
                        <li
                          v-for="user in searchUsers"
                          :key="user.number"
                          @click="addUser(user)"
                        >
                          <a>
                            <img
                              :src="user.avatar"
                              style="
                                width: 30px;
                                height: 30px;
                                border-radius: 15px;
                              "
                            />
                            {{ user.name }}（{{ user.email }}）
                            <span
                              :class="[
                                'glyphicon',
                                user.exist
                                  ? 'glyphicon-minus-sign'
                                  : 'glyphicon-plus-sign',
                              ]"
                              aria-hidden="true"
                            ></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div
                      class="share-search user-search-to1"
                      v-show="noSearchUsers && showSearchList"
                      v-clickoutside="closeSearchList"
                    >
                      <ul>
                        <li>
                          <a>未搜索到任何用户</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span class="help-block" v-show="errors.has('user1')">{{
                    errors.first("user1")
                  }}</span>
                </div>

                <div
                  class="form-group group-search-from1"
                  v-show="activeTab == 'share-group'"
                >
                  <div class="share-user">
                    <div
                      class="list"
                      v-for="group in form.groups"
                      :key="group.group_number"
                    >
                      <img :src="group.group_logo" />
                      <p>{{ group.group_name }}</p>
                      <i
                        class="iconfont icon-close close"
                        @click="removeGroup(group)"
                      ></i>
                    </div>
                    <input
                      ref="groupSearch"
                      type="text"
                      class="share-input"
                      v-model.trim="searchGroupName"
                      placeholder="输入群组名或群号搜索"
                      @focus="groupSearch"
                    />
                    <div
                      class="share-search group-search-to1"
                      v-show="searchGroups.length && showSearchList"
                      v-clickoutside="closeSearchList"
                    >
                      <ul>
                        <li
                          v-for="group in searchGroups"
                          :key="group.number"
                          @click="addGroup(group)"
                        >
                          <a>
                            <img
                              :src="group.group_logo"
                              style="
                                width: 30px;
                                height: 30px;
                                border-radius: 15px;
                              "
                            />
                            {{ group.group_name }}
                            <span
                              :class="[
                                'glyphicon',
                                group.exist
                                  ? 'glyphicon-minus-sign'
                                  : 'glyphicon-plus-sign',
                              ]"
                              aria-hidden="true"
                            ></span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div
                      class="share-search group-search-to1"
                      v-show="noSearchGroups && showSearchList"
                    >
                      <ul>
                        <li>
                          <a>未搜索到任何已加入的群组</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <span class="help-block" v-show="errors.has('group1')">{{
                    errors.first("group1")
                  }}</span>
                </div>

                <div
                  aria-controls="collapseShareSelected"
                  aria-expanded="true"
                  class="form-group"
                  data-toggle="collapse"
                  href="#collapseShareSelected"
                  @click="setStrategy"
                >
                  设置策略
                  <i
                    :class="{
                      'ti-angle-up': strategy,
                      'ti-angle-down': !strategy,
                    }"
                  ></i>
                </div>
                <div
                  class="share-tactics collapse in"
                  id="collapseShareSelected"
                >
                  <div class="form-group" v-show="activeTab === 'share-link'">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="密码"
                        v-model.trim="form.password"
                        name="password1"
                        data-vv-as="密码 "
                        v-validate="{ max: 36 }"
                      />
                      <span class="input-group-btn">
                        <button
                          class="btn btn-link"
                          type="button"
                          @click="createPassword"
                        >
                          自动生成
                        </button>
                      </span>
                    </div>
                    <span class="help-block" v-show="errors.has('password1')">{{
                      errors.first("password1")
                    }}</span>
                  </div>
                  <div class="form-group">
                    <div class="input-group" @click="getFormatDateFocus">
                      <input
                        class="form-control"
                        placeholder="有效期"
                        type="text"
                        v-model.trim="form.date"
                        name="date1"
                        data-vv-as="有效期 "
                        v-validate="'date_format:yyyy-MM-dd'"
                      />
                      <div class="input-group-addon">
                        <i class="ti-calendar"></i>
                      </div>
                    </div>
                    <span class="help-block" v-show="errors.has('date1')">{{
                      errors.first("date1")
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal" type="button">
              取消
            </button>
            <button class="btn btn-primary" type="button" @click="createShare">
              <span>确定</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-labelledby="myModalLabel"
      class="modal fade"
      id="share2link"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="tab-content" id="myTabContent">创建分享成功！</div>
            <div class="tab-content" id="myTabContent">
              分享地址：{{ sharedLink }}
              <button
                type="button"
                ref="copy12"
                class="btn btn-primary btn-xs"
                @click="copy"
              >
                {{ copyText }}
              </button>
            </div>
            <div class="tab-content" v-if="pwd">{{ pwd }}</div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal" type="button">
              <span>确定</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { createShare } from "@/api/share/share";
import { getGroups } from "@/api/group/group";
import { userSearch } from "@/api/user/user";
import { getFormatDate } from "@/utils/index";
export default {
  name: "TableShareSelected",
  data() {
    return {
      showSearchList: true,
      pwd: "",
      copyText: "复制链接及密码",
      noSearchUsers: false,
      noSearchGroups: false,
      searchUserName: "",
      searchGroupName: "",
      searchUsers: [],
      searchGroups: [],
      sharedLink: "",
      copyContent: "",
      strategy: true,
      activeTab: "share-link",
      users: [],
      form: {
        title: "",
        resource_list: [],
        password: "",
        date: "",
        users: [],
        groups: [],
      },
    };
  },
  created() {
    this.debouncedUserSearch = debounce(this.userSearch, 500);
    this.debouncedGroupSearch = debounce(this.groupSearch, 500);
  },
  watch: {
    searchUserName: {
      handler: function (newValue) {
        if (newValue.trim()) {
          this.debouncedUserSearch();
        } else {
          this.noSearchUsers = false;
        }
      },
    },
    searchGroupName: {
      handler: function (newValue) {
        if (newValue.trim()) {
          this.debouncedGroupSearch();
        } else {
          this.noSearchGroups = false;
        }
      },
    },
  },
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
  computed: {
    selectedDatas() {
      return this.$store.state.drive.selectedDatas;
    },
    groupNumber() {
      return this.$store.state.drive.groupNumber;
    },
  },
  methods: {
    closeSearchList() {
      this.showSearchList = false;
      this.searchUserName = "";
      this.searchGroupName = "";
    },
    copy() {
      let container = this.$refs.copy12;
      this.$copyText(this.copyContent, container)
        .then(() => {
          this.copyText = "已复制";
        })
        .catch(() => {
          this.copyText = "复制失败";
          alert("复制失败，建议您手动复制");
        });
      setTimeout(() => {
        this.copyText = "重新复制";
      }, 2000);
    },
    addUser(data) {
      this.errors.remove("user1");
      let exist = this.form.users.find(
        (item) => item.user_number === data.user_number
      );
      let index = this.form.users.indexOf(exist);
      if (index > -1) {
        this.form.users.splice(index, 1);
      } else {
        this.form.users.push(data);
      }
      this.searchUsers = [];
      this.searchUserName = "";
      this.$refs.userSearch.focus();
      this.changeSearchHeight("user-search");
    },
    addGroup(data) {
      this.errors.remove("group1");
      let exist = this.form.groups.find(
        (item) => item.group_number === data.group_number
      );
      let index = this.form.groups.indexOf(exist);
      if (index > -1) {
        this.form.groups.splice(index, 1);
      } else {
        this.form.groups.push(data);
      }
      this.searchGroups = [];
      this.searchGroupName = "";
      this.changeSearchHeight("group-search");
    },
    changeSearchHeight(preName) {
      this.$nextTick(() => {
        let c1 = document.getElementsByClassName(preName + "-from1")[0];
        let height = c1.clientHeight + 119 + "px";
        let c2 = document.getElementsByClassName(preName + "-to1");
        for (let i = 0; i < c2.length; i++) {
          c2[i].style.top = height;
        }
      });
    },
    setStrategy() {
      this.strategy = !this.strategy;
    },
    createShare() {
      this.$validator.validate("title1").then((valid) => {
        if (valid) {
          switch (this.activeTab) {
            case "share-user":
              this.createUserShare("user");
              break;
            case "share-group":
              this.createUserShare("group");
              break;
            default:
              this.createLinkShare();
              break;
          }
        }
      });
    },
    clearForm() {
      this.form.title = "";
      this.form.resource_list = [];
      this.form.password = "";
      this.form.date = "";
      this.form.users = [];
      this.form.groups = [];
    },
    setDetail() {
      this.form.resource_list = this.selectedDatas.map(function (item) {
        return item.number;
      });
    },
    switchTab(tabName) {
      this.activeTab = tabName;
    },
    removeUser(user) {
      let exist = this.searchUsers.find(
        (item) => item.user_number === user.user_number
      );
      if (exist) {
        exist.exist = false;
      }
      let index = this.form.users.indexOf(user);
      this.form.users.splice(index, 1);
      this.changeSearchHeight("user-search");
    },
    removeGroup(group) {
      let exist = this.searchGroups.find(
        (item) => item.group_number === group.group_number
      );
      if (exist) {
        exist.exist = false;
      }
      let index = this.form.groups.indexOf(group);
      this.form.groups.splice(index, 1);
      this.changeSearchHeight("group-search");
    },
    createLinkShare() {
      let params = {
        share_title: this.form.title,
        resource_list: this.form.resource_list,
        share_type: "link",
      };
      if (this.strategy) {
        if (this.errors.has("password1") || this.errors.has("date1")) {
          return false;
        } else {
          params.share_constraint = {
            date: this.form.date ? this.form.date : null,
            password: this.form.password ? this.form.password : null,
          };
        }
      }
      createShare(params)
        .then((res) => {
          if (res.status_code === 200) {
            $("#share2").modal("hide");
            let routeUrl = this.$router.resolve({
              name: "sharelink",
              params: { share_number: res.entity.share_number },
            });
            this.sharedLink = window.location.origin + routeUrl.href;
            if (this.strategy && this.form.password) {
              this.copyText = "复制链接及密码";
              this.pwd = `密码：${this.form.password}`;
            } else {
              this.pwd = "";
              this.copyText = "复制链接";
            }
            this.copyContent = `链接：${this.sharedLink}${this.pwd}`;
            $("#share2link").modal("show");
            this.clearForm();
            this.$nextTick(() => {
              this.$validator.reset();
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    createUserShare(shareType) {
      let sharer_target_number;
      if (shareType === "user") {
        if (this.form.users.length < 1) {
          this.errors.add({
            field: "user1",
            msg: "请先添加用户",
          });
          return false;
        }
        sharer_target_number = this.form.users.map((user) => {
          return user.user_number;
        });
      } else if (shareType === "group") {
        if (this.form.groups.length < 1) {
          this.errors.add({
            field: "group1",
            msg: "请先添加群组",
          });
          return false;
        }
        sharer_target_number = this.form.groups.map((group) => {
          return group.group_number;
        });
      }
      this.$validator.validate("date").then((valid) => {
        if (valid || !this.strategy) {
          let params = {
            share_type: shareType,
            share_title: this.form.title,
            sharer_target_number: sharer_target_number,
            resource_list: this.form.resource_list,
          };
          if (this.strategy) {
            params.share_constraint = {
              date: this.form.date ? this.form.date : null,
            };
          }
          createShare(params)
            .then((res) => {
              if (res.status_code === 200) {
                $("#share2").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.clearForm();
                this.$nextTick(() => {
                  this.$validator.reset();
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.$message({
                type: "error",
                message: err,
              });
            });
        }
      });
    },
    createPassword() {
      let password = Math.random().toString(36).substr(2, 4);
      this.form.password = password;
    },
    userSearch() {
      userSearch(this.searchUserName)
        .then((res) => {
          this.showSearchList = true;
          if (res.entity.length === 0) {
            this.noSearchUsers = true;
          } else {
            this.noSearchUsers = false;
          }
          this.searchUsers = res.entity.map((item) => {
            if (
              this.form.users.find((it) => it.user_number === item.user_number)
            ) {
              item.exist = true;
            } else {
              item.exist = false;
            }
            return item;
          });
        })
        .catch();
    },
    groupSearch() {
      getGroups({
        search_name: this.searchGroupName,
        group_review: "adopt",
      })
        .then((res) => {
          this.showSearchList = true;
          if (res.entity.total === 0) {
            this.noSearchGroups = true;
          } else {
            this.noSearchGroups = false;
          }
          this.searchGroups = res.entity.datas.map((item) => {
            if (
              this.form.groups.find(
                (it) => it.group_number === item.group_number
              )
            ) {
              item.exist = true;
            } else {
              item.exist = false;
            }
            return item;
          });
        })
        .catch();
    },
    getFormatDateFocus(event) {
      $(event.currentTarget)
        .find("input:first-child")
        .datetimepicker({
          format: "yyyy-mm-dd",
          weekStart: 1,
          autoclose: true,
          startView: 2,
          minView: 2,
          pickerPosition: "bottom-right",
          language: "zh-CN",
          startDate: getFormatDate(),
        })
        .datetimepicker("show")
        .on("changeDate", (ev) => {
          this.form.date = getFormatDate(ev.date.valueOf());
        })
        .on("hide", (ev) => {
          $(ev.currentTarget).datetimepicker("remove");
        });
    },
  },
  mounted: function () {
    let that = this;
    $("#share2").on("show.bs.modal", function (e) {
      that.$nextTick(() => {
        that.setDetail();
        that.$validator.reset();
      });
    });
  },
  destroyed() {
    $("#share2").off();
  },
};
</script>

<style scoped>
.tab-content .btn-xs {
  padding: 1px 5px;
  margin-bottom: 2px;
}
.text-danger2 {
  color: red;
}
.text-danger2 a {
  color: red;
}
.text-danger2 a:hover {
  text-decoration: underline;
}
</style>